import { render, staticRenderFns } from "./work-menu.vue?vue&type=template&id=062fffcf&scoped=true"
import script from "./work-menu.vue?vue&type=script&lang=ts"
export * from "./work-menu.vue?vue&type=script&lang=ts"
import style0 from "./work-menu.vue?vue&type=style&index=0&id=062fffcf&prod&lang=less&scoped=true"
import style1 from "./work-menu.vue?vue&type=style&index=1&id=062fffcf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062fffcf",
  null
  
)

export default component.exports